import { i18n } from "../boot";

export default function replaceNonDigits(str: string): string {
  if (!str) return "";
  const currentLanguage = i18n.language;
  const isDe = currentLanguage === "de";
  const regex = isDe ? /[^\d,-]/g : /[^\d.-]/g;
  const [int, decimal = null] = str.replace(regex, "").split(isDe ? "," : ".");
  const hasDecimal = decimal !== null;
  if (hasDecimal) {
    return [int, decimal.slice(0, 2)].join(".");
  }
  return int;
}
